export default __webpack_public_path__ + "static/media/elite.5bdb3f18.svg";